<template>
  <v-sheet color="white">
  <v-layout>
    <v-container id="join-container">
       <v-row>
      <v-col></v-col>
      <v-col
          cols="sm" sm="8" md="6">
        <v-alert
          v-model="show_error"
          type="error"
          class="mx-auto"
          close-text="Close"        
        ><p>We experienced the following error: </p>
        <p>{{ plan_error ? plan_error.message : '' }}</p>
        <p>Please try again or contact us if the problem persists</p></v-alert>
      </v-col>
      <v-col></v-col>
    </v-row>

      <v-row align="center">
        <v-col class="text-center">
          <h2 class="main-title secondary--text">
            <span>Select a plan</span>
          </h2>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="text-center grey--text">
            <span>Please install Motiplate from the app store first to confirm compatibility with your phone*</span>
            <br />
            <small class="grey--text">*Android only. Coming soon for iPhone</small>
      
        </v-col>
      </v-row>
      <v-row align="center">

        <v-col class="text-center" cols="sm" sm="4">
          <v-card  
            color="secondary"
            class="mx-auto ribbon"
            min-height="160"
          >
          <v-card-title class="justify-center card-text">Month</v-card-title>
            <v-card-text>
              <!-- <p>
                <v-icon x-large class="card-icon card-text">mdi-cash-multiple</v-icon>
              </p> -->
              <div class="ribbon">
                <div class="wrap-left">
                  <span class="ribbon-primary ribbon-left secondary--text text--darken-3">Special Offer</span>
                </div>
              </div>
              <p class="card-text display-1">
                R&nbsp;29.99*
              </p>  
              <p class="card-text">
                R 29.99* charged every month
                </p>
                <p class="card-text font-italic">
                * Normally R 49.99/m
              </p>      
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark text @click="subscribe('plan_GQ3LyTq2AGeluQ')" :loading="busy_subscribing" >
                Subscribe
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>




        <v-col class="text-center" cols="sm" sm="4">
          <v-card  
            color="primary"
            class="mx-auto py-8"
            min-height="160"
            height="100%"
            elevation="10"
          >
          <v-card-title class="justify-center card-text pt-10 display-1">Annual</v-card-title>
            <v-card-text>
              <!-- <p>
                <v-icon x-large class="card-icon card-text">mdi-cash-multiple</v-icon>
              </p> -->
              <div class="ribbon">
                <div class="wrap-straight">
                  <span class=" headline ribbon-secondary ribbon-straight white--text font-weight-light">Best Value</span>
                </div>
              </div>
              <p class="card-text display-2">
                R 359.88
              </p>       
              <p class="card-text">
                R 359.88 charged anually
              </p>     
              <p class="card-text font-italic">
                This subscription works out to only R 29.99/m!
              </p>      
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark text @click="subscribe('plan_GQ3LR9EOARsSgy')" :loading="busy_subscribing">
                Subscribe
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>


        <v-col class="text-center" cols="sm" sm="4">
          <v-card  
            color="secondary"
            class="mx-auto"
            min-height="160"
          >
          <v-card-title class="justify-center card-text">6 Month</v-card-title>
            <v-card-text>
              <!-- <p>
                <v-icon x-large class="card-icon card-text">mdi-cash-multiple</v-icon>
              </p> -->
              <div class="ribbon">
                <div class="wrap-right">
                  <span class="ribbon-primary ribbon-right secondary--text text--darken-3">Special Offer</span>
                </div>
              </div>
              <p class="card-text display-1">
                R&nbsp;179.94*
              </p>  
              <p class="card-text">
                R 179.94* charged every 6 months
                </p>
                <p class="card-text font-italic">
                * Normally R 239.94 (R 39.99/m) 
              </p>                
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark text @click="subscribe('plan_GQ3LPSfdZx2OuW')" :loading="busy_subscribing" >
                Subscribe
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>








  <v-snackbar color="error" multi-line top v-model="showSubscribeError" :timeout="signupTimeout">
      There was a problem signing you up.  Please confirm that the email is correct.<br />
      Please contact us if you are having trouble.
      <v-btn
        text
        @click="hideSubscribeError"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-sheet>
</template>
<script>
import { types as UserStoreTypes } from "../store/user";
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState('User', {
      user: state => state.user,
    }),
    ...mapState('Subscriptions', {
      busy_subscribing: state => state.loading,
      plan_error: state => state.plan_error
    }),
    formValid() {
      return (
        this.valid &&
        this.reCaptcha.verify !== null &&
        this.reCaptcha.verify !== undefined
      );
    },
    // subscribing() {
    //   this.isSubscribed = localStorage.getItem('subscribed');
    //   return this.$store.getters[UserStoreTypes.getters.IS_SUBSCRIBING];
    // },
    subscribeError() {
      return this.$store.getters[UserStoreTypes.getters.ERROR_SUBSCRIBE];
    },
    show_error() {
      return this.plan_error ? true : false;
    }
  },
  watch: {
    // subscribing(value) {
    // },
    subscribeError(cur) {
      this.showSubscribeError = cur
    }
  },
  data() {
    return {
      email: "",
      valid: false,
      showSubscribeError: false,
      signupTimeout: 0,
      isSubscribed: false,
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      reCaptcha: {
        sitekey: "6LdxabcUAAAAANKUsxMlHX4ip8m_Ldi4Vs8WRxkv", //'6Lc5P7EUAAAAAMljM3BwrnpM47K-hiRjeH2C8BT_'
        verify: null
      }
    };
  },
  methods: {
    ...mapActions('Subscriptions', [
      'selectPlan'
    ]),
    ...mapMutations('Ui', [
      'login_dialog',
    ]),
    subscribe(product) {
      //this.$refs.subscribeForm.validate();
      // if (this.valid) {
      //   // Save the message
      //   this.$store.dispatch(UserStoreTypes.actions.SUBSCRIBE_LEAD, this.email);
      // } else {
      //   this.showSubscribeError = true;
      // }
      this.selectPlan(product)
      .then(() => {         
        // Log in if logged out
        if (!this.user) {
          this.login_dialog({ show: true, redirect_url: 'account/checkout' })
        } else {
          this.$router.push('/account/checkout');
        }
      })
      .catch(() => {
      })
    },
    clear() {
      this.resetRecaptcha();
      this.$refs.subscribeForm.reset();
    },
    onVerify: function(response) {
      this.reCaptcha.verify = response;
      this.$refs.subscribeForm.validate();
      if (this.valid && this.reCaptcha.verify) {
        // Save the message
        this.$store.dispatch(UserStoreTypes.actions.SUBSCRIBE_LEAD, this.email);
      } else {
        this.showSubscribeError = true;
      }
      //this.$store.commit('clearLoginError'); // Reset reCaptcha
      this.resetRecaptcha();
    },
    onExpired: function() {
      this.reCaptcha.verify = null;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.reCaptcha.verify = null;
    },
    hideSubscribeError() {
      this.showSubscribeError = false;
      this.$store.commit(UserStoreTypes.mutations.ERROR_SUBSCRIBE, null);
    }
  },
  components: {
  }
};
</script>
<style scoped>
#pricing-layout {
  padding: 50px 0px;
}

.pricing-signup {
  margin-top: 20px;
}

.card-text {
  color: white
}





.wrap-right {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: 8px;
  overflow: hidden;
}

.wrap-left {
  width: 100%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: -8px;
  overflow: hidden;
}

.wrap-straight {
  width: 106%;
  height: 188px;
  position: absolute;
  top: -8px;
  left: -3%;
  overflow: hidden;
}

.wrap-left:before, .wrap-left:after, .wrap-right:before, .wrap-right:after, .wrap-straight:before, .wrap-straight:after {
  content: ""; 
  position: absolute;
}

.wrap-right:before {
  width: 40px;
  height: 8px;
  right: 100px;
  background: #4D6530;
  border-radius: 8px 8px 0px 0px;
}

.wrap-left:before {
  width: 40px;
  height: 8px;
  left: 100px;
  background: #4D6530;
  border-radius: 8px 8px 0px 0px;
}

.wrap-straight:before {
  width: 3%;
  height: 8px;
  left: 0px;
  top: 70px;
  background: #4D6530;
  border-radius: 0px 0px 0px 8px;
}

.wrap-right:after {
  width: 8px;
  height: 40px;
  right: 0px;
  top: 100px;
  background: #4D6530;
  border-radius: 0px 8px 8px 0px;
}

.wrap-left:after {
  width: 8px;
  height: 40px;
  left: 0px;
  top: 100px;
  background: #4D6530;
  border-radius: 0px 8px 0px 8px;
}

.wrap-straight:after {
  width: 3%;
  height: 8px;
  right: 0px;
  top: 70px;
  background: #4D6530;
  border-radius: 0px 0px 8px 0px;
}

.ribbon-primary {
  width: 200px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 30px;
  z-index: 2;
  overflow: hidden;
  border: 1px dashed;
  text-align: center;
  box-shadow:0 0 0 3px #f7be21,  0px 21px 5px -18px rgba(0,0,0,0.6);
  background: #f7be21;
}

.ribbon-right {
  right: -50px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.ribbon-left {
  left: -50px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.ribbon-straight {
  top: 50px;
}


.ribbon-secondary {
  width: 102%;
  left: -1%;
  height: 40px;
  line-height: 40px !important;
  position: absolute;
  top: 30px;
  z-index: 2;
  overflow: hidden;
  border: 1px dashed;
  text-align: center;
  box-shadow:0 0 0 3px #5fc5c2,  0px 21px 5px -18px rgba(0,0,0,0.6);
  background: #5fc5c2;
}


</style>